import React from 'react';

import { PageId } from 'utils/ubi/pageId';

import InternalLink, { LinkProps } from './InternalLink';

const parentCategoryLink = (parentCategorySlug: string) => (market: string) =>
  `/${market}/category/${parentCategorySlug}/`;

interface CategoryLinkProps extends LinkProps {
  parentCategorySlug: string;
}

const ParentCategoryLink = ({ parentCategorySlug, ...props }: CategoryLinkProps) => (
  <InternalLink toPage={PageId.Category} hrefFun={parentCategoryLink(parentCategorySlug)} {...props} />
);

export default ParentCategoryLink;
